import { mapState, mapMutations, mapGetters } from 'vuex'
import store from '../store'
import _, { result } from 'lodash'
import i18n from '../i18n'
export default {
  filters: {
    toprice: (val, fixedCount, flag) => {
      val += ''
      let nVal = ''
      if (Number(val||0) >= 0) {
        nVal = flag ? '+' : ''
        nVal += fixedCount ? '$'+Number(val||0).toFixed(fixedCount) : '$'+(val||0)
      } else {
        nVal = fixedCount ? '-$'+Number(-val||0).toFixed(fixedCount) : '-$'+(-val||0)
      }
      if(!nVal.includes('.')) {
        nVal += '.'
      }
      return nVal.replace(/(\d)(?=(\d{3})+\.)/g, ($0,$1) => $1 + ',').replace(/\.$/, '')
    },
    tothousands: (val, flag) => {
      val += ''
      let nVal = ''
      if (Number(val||0) > 0) {
        nVal = (flag ? '+' : '') + val
      } else {
        nVal = val
      }
      if(!nVal.includes('.')) {
        nVal += '.'
      }
      return nVal.replace(/(\d)(?=(\d{3})+\.)/g, ($0,$1) => $1 + ',').replace(/\.$/, '')
    },
    toimg: imgId => {
      if (imgId && imgId.includes('http')) {
        return imgId
      } else if (imgId) {
        return store.state.aliUrl_x + '/' + imgId
      } else {
        return store.state.defaultLogo_x
      }
    },
    toimgs: imgIds => {
      let newArr = []
      imgIds.forEach(x => {
        if (x && x.includes('http')) {
          newArr.push(x)
        } else if (x) {
          newArr.push(store.state.aliUrl_x + '/' + x)
        } else {
          newArr.push(store.state.defaultLogo_x)
        }
      })
      return newArr
    },
    toremark: (item, flag) => {
      if (item.remarks || (item.remarksTemplateList && item.remarksTemplateList.length)) {
        let val = ''
        if (item.remarksTemplateList) {
          const ARR = item.remarksTemplateList.map(x1 => x1.remark)
          val += ARR.join(', ')
        }
        if (item.remarks) {
          if (val) {
            val += ', ' + item.remarks
          } else {
            val = item.remarks
          }
        }
        return val
      }
      if (flag) {
        return i18n.t('remark.remark')
      }
      return ''
    },
  },
  data() {
    return {
      defaultImg: store.state.defaultLogo_x,
      fromPage: '',
      iconCheckok: require('@/assets/icons/gou-ok.png'),
      iconChecknull: require('@/assets/icons/gou-null.png'),
      iconCheckdis: require('@/assets/icons/gou-dis.png'),
      iconCheckok2: require('@/assets/icons/gou-ok2.png'),
      iconChecknull2: require('@/assets/icons/gou-null2.png'),
      iconArrowLeft: require('@/assets/icons/arrow-left.png'),
      iconAdd1: require('@/assets/icons/add1.png'),
      iconDelete: require('@/assets/icons/delete.png'),
      iconSubtract1: require('@/assets/icons/subtract1.png'),
      iconAdd1dis: require('@/assets/icons/add1-dis.png'),
      iconSubtract1dis: require('@/assets/icons/subtract1-dis.png'),
      iconAdd2: require('@/assets/icons/add2.png'),
      iconSubtract2: require('@/assets/icons/subtract2.png'),
      iconKeyboard: require('@/assets/icons/keyboard.png'),
      iconCheckCoupon: require('@/assets/icons/checkCoupon.svg'),
      el_loading: false,
      // message_instance: null,
    }
  },
  computed: {
    ...mapState([
      'login_x',
      'user_x',
      'waiter_x',
      'shop_x',
      'company_x',
      'reasonTemp_x',
      'scene_x',
      'aliUrl_x',
      'sysEnv_x',
      'messageInstance_x',
      'sceneId_x',
      'modelList_x',
      'homePage_x',
      'printer_x',
      'reader_x',
      'networkStatus_x',
      'el_loading_x',
      'el_loading_long_x',
      'menuCount_x',
      'bellOpen_x',
      'bellRing_x',
      'bellOrderIds_x',
    ]),
    ...mapGetters(['printerId_x', 'readerId_x']),
    currentRoute() { return this.$route.name.replace('/', '') },
    isDev() { return process.env.NODE_ENV === 'development' },
    isPro() { return process.env.NODE_ENV === 'production' },
    currentShopId() { return this.shop_x.id || Number(this.$route.query.sid) },
    
    companyConfig_m() {
      return this.company_x.companyConfig || {}
    },
    // 是否显示会员
    isShowMember() {
      return this.companyConfig_m.customerOpen
    },
    // 是否显示VIP
    isShowVip() {
      return this.companyConfig_m.vipEnable
    },
    // 是否显示会员钱包
    isShowMemberWallet() {
      return this.companyConfig_m.customerWalletEnable
    },

    // 开台开启更换支付渠道
    isShowWhetherOpenPayment() {
      return this.company_x && this.company_x.whetherOpenPayment
    },
    // 开台是否输入人数
    isShowOpenTableDirect() {
      return this.company_x && this.company_x.openTableDirect
    },
    // 是否显示发送厨房时间
    isShowTimeOfPlaceOrders() {
      return this.company_x && this.company_x.timeOfPlaceOrders
    },
    // 是否运行发送厨房的菜品转台
    isShowDishMovementEnable() {
      return this.company_x && this.company_x.dishMovementEnable
    },
    // 是否展示追单
    isShowDishReminderEnable() {
      return this.company_x && this.company_x.dishReminderEnable
    },
    // 是否显示12味功能
    isShowFunctionAboutTwelveFlavors() {
      return this.company_x && this.company_x.labelInner === 'twelveflavors'
    },
    // 是否显示服务员模式
    isShowWaiterModel() {
      return this.company_x && this.company_x.enableEmployeeModule
    },
    // 是否显示拍照打卡
    isShowWaiterTakePhoto() {
      return this.company_x && this.company_x.enableEmployeeModule && this.company_x.employeePhoto
    },
    // 是否支付成功弹框改为绿色消息
    isShowNewWindow() {
      return this.company_x && this.company_x.popup
    },

    shopConfig_m() {
      return this.shop_x.shopConfig || {
        inventoryEnable: false, // 展示库存管理
        itemImgBEndEnable: false, // 展示菜品封面
        printerDelay: false, // 展示打印勾选框
        partPay_b: false, // 显示分钱分菜
        lineUpQr: true,
        consumptionTax: 0, // 消费税比例
        packageFeeSelect: 1, // 打包费类型
        packageFeeFloat: 1, // 打包费固定值
        tableInfoDisplayType: 1, // 餐桌信息显示类型 1餘位 2落單計時 3開台計時
        bookConfig: {
          openShieldReserve: false,
          maxPeople: Infinity,
          bookTimeList: [],
        },
        // enableScreeAutoLock: false, // 是否自动锁屏
        screeAutoLockTime: 30, // 自动锁屏时间
      }
    },
    bookConfig_m() {
      return this.shopConfig_m.bookConfig || {
        openShieldReserve: false,
        maxPeople: Infinity,
        bookTimeList: [],
      }
    },

    lang() {
      return this.$i18n.locale
    },
    _lang() {
      return '_' + this.lang
    },
  },
  methods: {
    ...mapMutations([
      'shop_x_save',
      'company_x_save',
      'messageInstance_x_save',
      'el_loading_x_save',
      'el_loading_long_x_save',
      'menuCount_x_save',
      'scan_canLeave_x_save',
      'bellOpen_x_save',
      'bellRing_x_save',
      'bellRing_x_save_once',
      'bellOrderIds_x_save',
    ]),

    onFocus_forScan() {
      this.scan_canLeave_x_save(false)
    },
    onBlur_forScan() {
      const timer = setTimeout(() => {
        this.scan_canLeave_x_save(true)
        clearTimeout(timer)
      }, 2000)
    },

    // #region 通用请求
    newData(sign, rD) {
      return this.$api.util_create(sign, rD).then(res => {
        if (res.status == 0) {
          return res.data || 'ok'
        } else { this._status(res) }
      })
    },
    getData(sign, rD, { replace, back } = {}) {
      return this.$api.util_search(sign, rD).then(res => {
        if (res.status == 0) {
          replace && this.pageData && (this.pageData.total = res.size)
          if (back) {
            return res.size
          } else {
            return res.data || 'ok'
          }
        } else { this._status(res) }
      })
    },
    setData(sign, rD) {
      return this.$api.util_modify(sign, rD).then(res => {
        if (res.status == 0) {
          return res.data || 'ok'
        } else { this._status(res) }
      })
    },
    delData(sign, rD) {
      return this.$api.util_delete(sign, rD).then(res => {
        if (res.status == 0) {
          return res.data || 'ok'
        } else { this._status(res) }
      })
    },
    // #endregion

    createQrcode(rD) {
      return this.$api.qrcode_create(rD).then(res => {
        if (res.status == 0) {
          let _R = res.data
          // console.log(_R)
          return _R
        } else { this._status(res) }
      })
    },

    async getUserLoginStatus() {
      return this.$api.user_login_get().then(res => {
        if (res.status == 0) {
          const result = res.data
          if (!result) {
            // 登录失效
            this.$router.push('/login')
          }
          return result
        } else { this._status(res) }
      })
    },

    getShopData(id = this.currentShopId) {
      let rD = { id }
      return this.$api.util_search('shop', rD).then(res => {
        if (res.status == 0) {
          let _Rs = res.data
          let _R = _Rs[0]
          if (_R) {
            this.shop_x_save(_R)
            // console.log(`%c店铺:`, 'color: #00f;', this.shop_x)
            return _R
          } else {
            this.$message.warning(this.$t('index.errorMessage'))
            this.$router.push('/login')
          }
        } else { this._status(res) }
      })
    },
    getShopCompanyData(id = this.currentShopId) {
      let rD = { id }
      return this.$api.util_search('shop', rD).then(async res => {
        if (res.status == 0) {
          let _Rs = res.data
          let _R = _Rs[0]
          if (_R) {
            this.shop_x_save(_R)
            // console.log(`%c店铺:`, 'color: #00f;', this.shop_x)
            await this.getCompanyData(_R.companyId)
            return _R
          } else {
            this.$message.warning(this.$t('index.errorMessage'))
            this.$router.push('/login')
          }
        } else { this._status(res) }
      })
    },
    getCompanyData(id = this.shop_x.companyId) {
      let rD = { id }
      return this.$api.util_search('company', rD).then(res => {
        if (res.status == 0) {
          let _Rs = res.data
          let _R = _Rs[0]
          if (_R) {
            this.company_x_save(_R)
            // console.log(`%c公司:`, 'color: #00f;', this.company_x)
            // console.log(`%c公司配置:`, 'color: #00f;', this.company_x.companyConfig)
            return _R
          } else {
            this.$message.warning(this.$t('index.errorMessage'))
            this.$router.push('/login')
          }
        } else { this._status(res) }
      })
    },
    couponFormat(coupon) {
      console.log(coupon)
      coupon.checked = false

      let {
        ticketType, atLeastCost,
        discountCash, discount, afterCost, afterCash,
        template, validType, bindingDays,
        startTime_ = startTime, endTime_ = endTime,
        shopList,
        takeout, tangshi, multiUsed,
        companyMainItemList, multiItemValid
      } = coupon || {}

      switch (ticketType) {
        case 1:
          coupon.desc_value_zh = '$' + discountCash
          coupon.desc_value_en = '$' + discountCash
          break
        case 2:
          coupon.desc_value_zh = discount + '折'
          coupon.desc_value_en = (Math.round((10 - discount) * 10 * 100) / 100) + '% Off'
          break
        case 3:
          if (afterCost) {
            coupon.desc_value_zh = '返' + afterCost + '%'
            coupon.desc_value_en = 'Get ' + afterCost + '%'
          } else {
            coupon.desc_value_zh = '返$' + afterCash
            coupon.desc_value_en = 'Get $' + afterCash
          }
          break
        case 4:
          coupon.desc_value_zh = '免费'
          coupon.desc_value_en = 'Free'
          break
      }
      
      if (template && validType === 2) {
        coupon.desc_time_zh = bindingDays ? `兌換後${(bindingDays)}天內有效` : ''
        coupon.desc_time_en = bindingDays ? `Valid for ${(bindingDays)} days after claimed` : ''
      } else {
        const datarange = endTime_ ? `${this.$tool.time_parse_ymd(startTime_, '/')}~${this.$tool.time_parse_ymd(endTime_, '/')}` : ''
        coupon.desc_time_zh = datarange
        coupon.desc_time_en = datarange
      }
      
      coupon.desc_threshold_zh = atLeastCost ? `滿$${atLeastCost}可用` : ''
      coupon.desc_threshold_en = atLeastCost ? `When spend $${atLeastCost} or more` : ''

      coupon.desc_shop_zh = (shopList && shopList.length) ? shopList.map(x => x.name_zh || x.name).join('，') : ''
      coupon.desc_shop_en = (shopList && shopList.length) ? shopList.map(x => x.name_en || x.name).join('，') : ''

      let types_zh = [], types_en = []
      tangshi && types_zh.push('堂食')
      tangshi && types_en.push('Dine-in')
      takeout && types_zh.push('外賣')
      takeout && types_en.push('Take-away')
      coupon.desc_orderType_zh = types_zh.length ? types_zh.join('&') : ''
      coupon.desc_orderType_en = types_en.length ? types_en.join(' & ') : ''

      coupon.desc_food_zh = companyMainItemList.length ? companyMainItemList.map(x => x.name_zh).join('，') : ''
      coupon.desc_food_en = companyMainItemList.length ? companyMainItemList.map(x => x.name_en).join('，') : ''
      
      let restrictions_zh = [], restrictions_en = []
      // 堂食可用
      // 外賣可用
      // 滿$100可用
      // 不可多張使用
      // 适用菜品所有可用/适用菜品一份可用
      tangshi && restrictions_zh.push('堂食可用')
      takeout && restrictions_zh.push('外賣可用')
      atLeastCost && restrictions_zh.push(`滿$${atLeastCost}可用`)
      multiUsed === false && restrictions_zh.push('不可多張使用')
      ticketType === 4 && restrictions_zh.push(multiItemValid ? '适用菜品所有可用' : '适用菜品一份可用')
      coupon.desc_restrictions_zh = restrictions_zh.length ? restrictions_zh.join('<br/>') : ''

      tangshi && restrictions_en.push('For Dine-in')
      takeout && restrictions_en.push('For Take-away')
      atLeastCost && restrictions_en.push(`When spend $${atLeastCost} or more`)
      multiUsed === false && restrictions_en.push('Cannot be applied with other coupons')
      ticketType === 4 && restrictions_en.push(multiItemValid ? 'Applicable for multiple food' : 'Applicable for single food')
      coupon.desc_restrictions_en = restrictions_en.length ? restrictions_en.join('<br/>') : ''

      return coupon
    },

    // 请求返回的状态值处理
    _status(res, cb) {
      console.log(`%c错误请求:`, 'color: #00f;', res)
      switch (res.status) {
        case 0: cb ? cb() : console.log('no callback running'); break
        case 4:
          // this.$message.error({'zh':res.msg, 'en':res.msgEn}[this.lang])
          // this.$router.push('/login')
          // break
        case 410:
          // console.log(`%cthis.message_instance1111:`, 'color: #00f;', this.messageInstance_x)
          if (this.messageInstance_x) {
            // this.messageInstance_x.close()
          } else {
            const instance = this.$message({
              message: {'zh':res.msg, 'en':res.msgEn}[this.lang],
              type: 'error',
              onClose: () => {
                this.messageInstance_x_save(null)
                // console.log(`%cthis.message_instance3333:`, 'color: #00f;', this.messageInstance_x)
              }
            })
            this.messageInstance_x_save(instance)
            
            this.$router.push('/login')
            // console.log(`%cthis.message_instance2222:`, 'color: #00f;', this.messageInstance_x)
          }
          break
        case 115:
          this.$message.error({'zh':res.msg, 'en':res.msgEn}[this.lang])
          // console.log(`%c11111111:`, 'color: #f00;', this.closeAllDialog)
          this.closeAllDialog && this.closeAllDialog()
          let timer = setTimeout(() => {
            this.$router.push('/order?type=orderManage2')
            clearTimeout(timer)
          }, 2000)
          break
        default:
          this.$message.error({'zh':res.msg, 'en':res.msgEn}[this.lang])
          break
      }
    },
    _scrollToBottom(dom) {
      let el = document.querySelector(dom)
      let step = 0
      let timer = setInterval(() => {
        console.log(el.scrollTop, el.scrollHeight - el.offsetHeight, el.scrollHeight, el.offsetHeight)
        if (el.scrollTop + 10 >= el.scrollHeight - el.offsetHeight) {
          clearInterval(timer)
          return
        }
        step += 10
        el.scrollTop += step
      }, 20)
    },
    throttle1000: _.throttle(function() {
      // console.log(arguments, ...arguments)
      let args = Array.from(arguments)
      // console.log(args, ...args, args.slice(1))
      this[args[0]](...args.slice(1))
    }, 500, {
      leading: true,
      trailing: false
    }),
    priceFormat(val) {
      return '$' + Number(val).toFixed(2)
    },
    toprice: (val, fixedCount, flag) => {
      val += ''
      let nVal = ''
      if (Number(val||0) >= 0) {
        nVal = flag ? '+' : ''
        nVal += fixedCount ? '$'+Number(val||0).toFixed(fixedCount) : '$'+(val||0)
      } else {
        nVal = fixedCount ? '-$'+Number(-val||0).toFixed(fixedCount) : '-$'+(-val||0)
      }
      if(!nVal.includes('.')) {
        nVal += '.'
      }
      return nVal.replace(/(\d)(?=(\d{3})+\.)/g, ($0,$1) => $1 + ',').replace(/\.$/, '')
    },
    tothousands: (val, flag) => {
      val += ''
      let nVal = ''
      if (Number(val||0) > 0) {
        nVal = (flag ? '+' : '') + val
      } else {
        nVal = val
      }
      if(!nVal.includes('.')) {
        nVal += '.'
      }
      return nVal.replace(/(\d)(?=(\d{3})+\.)/g, ($0,$1) => $1 + ',').replace(/\.$/, '')
    },
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.scan_canLeave_x_save(true)
    })
  },
}